import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const BRAND = {
  name: "Hope & Favor",
  legal: "Hope & Favor, LLC",
  motto: "Helping People Feel Seen, Encouraged & Supported.",
  tagline: "Thoughtfully Curated. Beautifully Given.",
  owner: "Ms. Lesah Martin",
  phone: "321-222-7729",
  email: "rayufsunshine@gmail.com",
  site: "hopeandfavor.com",
  logo: "https://customer-assets.emergentagent.com/job_hope-boxes/artifacts/sunuz054_GIFT%20-%20H%26F%20LOGO%20CIRCLE.png",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => `$${Number(n).toFixed(2)}`;

export function toEmbedUrl(url) {
  if (!url) return "";
  try {
    const u = url.trim();
    let m = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
    m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}`;
    return u;
  } catch { return url; }
}

export const PLACEHOLDER_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='400' height='400' fill='%23F2EFEB'/%3E%3Ctext x='50%25' y='50%25' font-family='serif' font-size='28' fill='%23C4A4A4' text-anchor='middle' dy='.3em'%3EGrace %26 Hope%3C/text%3E%3C/svg%3E";
